import React, { useState } from 'react';
import { Eye, EyeOff, Trash2, KeyRound, User, Globe } from 'lucide-react';

const CuentaCard = ({ cuenta, onEliminar }) => {
  const [verContrasena, setVerContrasena] = useState(false);

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div className="space-y-2 flex-grow">
        <div className="flex items-center gap-2">
          <Globe className="w-5 h-5 text-blue-600" />
          <p className="text-lg font-bold text-gray-800">{cuenta.plataforma}</p>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <User className="w-4 h-4" />
          <span>{cuenta.usuario}</span>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <KeyRound className="w-4 h-4" />
          <span>{verContrasena ? cuenta.contrasena : '••••••••••'}</span>
        </div>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-center">
        <button
          onClick={() => setVerContrasena(!verContrasena)}
          className="p-2 text-gray-500 hover:text-blue-600 transition-colors rounded-full hover:bg-gray-200"
          title={verContrasena ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        >
          {verContrasena ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
        {onEliminar && (
          <button
            onClick={() => onEliminar(cuenta)}
            className="p-2 text-gray-500 hover:text-red-600 transition-colors rounded-full hover:bg-gray-200"
            title="Eliminar cuenta"
          >
            <Trash2 size={18} />
          </button>
        )}
      </div>
    </div>
  );
};

export default CuentaCard;